import React from 'react';
import Link from './SmartLink';

const COLS = [
  {
    title: 'For Students',
    links: [
      { label: 'Find Jobs',       to: '/services#students' },
      { label: 'Internships',     to: '/services#students' },
      { label: 'Resume Builder',  to: '/services#students' },
      { label: 'Mock Interviews', to: '/services#students' },
      { label: 'Career Blog',     to: '#0' },
    ],
  },
  {
    title: 'For Recruiters',
    links: [
      { label: 'Post a Job',  to: '/services#recruiters' },
      { label: 'ATS',         to: '/services#recruiters' },
      { label: 'Analytics',   to: '/services#recruiters' },
      { label: 'Enterprise',  to: '/services#recruiters' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About',    to: '/about' },
      { label: 'Services', to: '/services' },
      { label: 'Press',    to: '#0' },
      { label: 'Contact',  to: '/contact' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy Policy',     to: '/privacy' },
      { label: 'Terms & Conditions', to: '/terms' },
      { label: 'Delete Account',     to: '/delete-account' },
      { label: 'Cookies',            to: '#0' },
    ],
  },
];

const SOCIALS = [
  { label: 'LinkedIn',    href: '#0' },
  { label: 'Twitter / X', href: '#0' },
  { label: 'Instagram',  href: '#0' },
  { label: 'YouTube',    href: '#0' },
];

export default function SharedFooter() {
  return (
    <footer className="bg-[#0a0a1e] border-t border-[rgba(99,102,241,0.15)] pt-16 pb-9 px-7">
      <div className="max-w-[1160px] mx-auto">

        {/* Top row — brand + columns */}
        <div className="flex justify-between items-start gap-12 flex-wrap mb-12">

          {/* Brand */}
          <div className="min-w-[220px]">
            <Link to="/" className="flex items-center gap-2.5 text-[21px] font-black tracking-[-0.05em] text-[#f1f1ff] no-underline mb-3">
              <img src="/trybinc_logo.png" alt="tryBinC" style={{ height: 28, width: 'auto' }} />
              tryBinC
            </Link>
            <p className="text-[13.5px] text-[#8888bb] max-w-[240px] leading-[1.65] mb-5">
              The AI-powered job platform for students launching careers and recruiters building world-class teams.
            </p>
            <div className="flex gap-3 flex-wrap">
              {SOCIALS.map(s => (
                <a
                  key={s.label}
                  href={s.href}
                  className="text-[12px] text-[#8888bb] no-underline px-3 py-1.5 bg-[#0f0f26] border border-[rgba(99,102,241,0.15)] rounded-lg transition-all hover:border-[#6366f1] hover:text-indigo-300"
                >
                  {s.label}
                </a>
              ))}
            </div>
          </div>

          {/* Link columns */}
          <div className="flex gap-12 flex-wrap">
            {COLS.map(col => (
              <div key={col.title}>
                <h4 className="text-[12px] font-extrabold uppercase tracking-[0.1em] text-[#8888bb] mb-4">
                  {col.title}
                </h4>
                <ul className="list-none flex flex-col gap-2.5">
                  {col.links.map(l =>
                    l.to.startsWith('/') ? (
                      <li key={l.label}>
                        <Link to={l.to} className="text-[14px] text-[#8888bb] no-underline transition-colors hover:text-[#f1f1ff]">
                          {l.label}
                        </Link>
                      </li>
                    ) : (
                      <li key={l.label}>
                        <a href={l.to} className="text-[14px] text-[#8888bb] no-underline transition-colors hover:text-[#f1f1ff]">
                          {l.label}
                        </a>
                      </li>
                    )
                  )}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-[rgba(99,102,241,0.15)] pt-6 flex flex-wrap items-center justify-between gap-4">
          <p className="text-[13px] text-[#8888bb]">
            © 2026 tryBinC, Inc. All rights reserved.
          </p>
          <p className="text-[13px] text-[#8888bb]">
            Built for the next generation of talent.
          </p>
        </div>

      </div>
    </footer>
  );
}
